import React from 'react';

import Grid from '@material-ui/core/Grid';

import PopularTags from './components/PopularTags';
import Categories from './components/Categories';

const Sidebar = ({ popularTags, categories }) => {
  return (
    <Grid container spacing={24}>
      <Grid item xs={12}>
        <PopularTags nodes={popularTags} />
      </Grid>
      <Grid item xs={12}>
        <Categories nodes={categories} />
      </Grid>
    </Grid>
  );
};

export default Sidebar;
